import { Container, Box } from '@mui/material';
import PolicyHeader from '../../../../../components/PolicyHeader';
import {
  ContentSectionWrapper,
  ContentContainer,
  LastUpdated,
  SectionTitle,
  SectionContent,
  SubsectionTitle,
  SubsectionText,
  ContactInfo,
  ContactItem,
  AddressBlock,
} from './styles';

const PolicyContentSection = ({ title, lastUpdated, children }) => {
  return (
    <ContentSectionWrapper>
      <Container maxWidth="lg">
        <ContentContainer>
          <PolicyHeader title={title} />
          <LastUpdated>{lastUpdated}</LastUpdated>
          {children}
        </ContentContainer>
      </Container>
    </ContentSectionWrapper>
  );
};

export default PolicyContentSection;

export {
  Box,
  SectionTitle,
  SectionContent,
  SubsectionTitle,
  SubsectionText,
  ContactInfo,
  ContactItem,
  AddressBlock,
};
